import api from './api';

// Services, Fees & Engagement Letter (onboarding Module 8).
export const servicesEngagementAPI = {
  // Service catalogue
  listCatalogue: () => api.get('/api/service-catalogue'),
  addCatalogue: (data) => api.post('/api/service-catalogue', data),
  updateCatalogue: (id, data) => api.patch(`/api/service-catalogue/${id}`, data),
  deleteCatalogue: (id) => api.delete(`/api/service-catalogue/${id}`),

  // Client selected services
  listSelected: (clientId) => api.get(`/api/clients/${clientId}/selected-services`),
  addSelected: (clientId, data) => api.post(`/api/clients/${clientId}/selected-services`, data),
  updateSelected: (clientId, id, data) => api.patch(`/api/clients/${clientId}/selected-services/${id}`, data),
  removeSelected: (clientId, id) => api.delete(`/api/clients/${clientId}/selected-services/${id}`),

  // Engagement letter
  listTemplates: () => api.get('/api/engagement-templates'),
  getGroup: (clientId) => api.get(`/api/clients/${clientId}/engagement-group`),
  generate: (clientId, data) => api.post(`/api/clients/${clientId}/engagement-letter/generate`, data),
  getLetter: (clientId) => api.get(`/api/clients/${clientId}/engagement-letter`),
  editLetter: (letterId, data) => api.patch(`/api/engagement-letters/${letterId}`, data),
  send: (letterId) => api.post(`/api/engagement-letters/${letterId}/send`),
  sign: (letterId, data) => api.post(`/api/engagement-letters/${letterId}/sign`, data),
  requestChanges: (letterId, data) => api.post(`/api/engagement-letters/${letterId}/request-changes`, data),
  document: (letterId) => api.get(`/api/engagement-letters/${letterId}/document`),
  downloadPdf: (letterId) => api.get(`/api/engagement-letters/${letterId}/pdf`, { responseType: 'blob' }),

  // Storage lists
  listAdmin: (params) => api.get('/api/engagement-letters', { params }),
  listForClient: (clientId) => api.get(`/api/clients/${clientId}/engagement-letters`),
};

export const BILLING_FREQUENCY_OPTIONS = [
  { value: 'one_off', label: 'One-off' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'annual', label: 'Annual' },
  { value: 'per_lodgement', label: 'Per lodgement' },
];

export const FEE_TYPE_OPTIONS = [
  { value: 'fixed', label: 'Fixed fee' },
  { value: 'hourly', label: 'Hourly' },
  { value: 'estimate', label: 'Estimate only' },
];

export const LETTER_STATUS_META = {
  draft: { label: 'Draft', color: 'bg-muted text-muted-foreground' },
  sent_to_client: { label: 'Sent to client', color: 'bg-blue-100 text-blue-800' },
  viewed_by_client: { label: 'Viewed by client', color: 'bg-cyan-100 text-cyan-800' },
  signed: { label: 'Signed', color: 'bg-green-100 text-green-800' },
  declined: { label: 'Declined', color: 'bg-red-100 text-red-800' },
  needs_changes: { label: 'Needs changes', color: 'bg-orange-100 text-orange-800' },
  stored: { label: 'Stored', color: 'bg-green-100 text-green-800' },
};

export const fmtMoney = (n) => `$${Number(n || 0).toFixed(2)}`;

// Downloads the letter PDF (authenticated blob) and saves it with a sensible filename.
export const downloadLetterPdf = async (letterId, filename) => {
  const res = await servicesEngagementAPI.downloadPdf(letterId);
  const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename || 'engagement-letter'}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
